module.exports = __webpack_public_path__ + "static/media/daniel-profile.2b01345f.jpeg";